import { createGlobalStyle } from "styled-components";

const AnimationStyles = createGlobalStyle`

//toaster animation
@keyframes slideInBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
} 

// rounded simple loader animation
@keyframes loader{
    0%{
        rotate: -360deg;
    }100%{
        rotate: 360deg;
    }
}

@keyframes shimmer {
  0% { transform: translateX(-150%) skewX(-25deg); }
  50% { transform: translateX(150%) skewX(-25deg); }
  100% { transform: translateX(150%) skewX(-25deg); }
}

@keyframes border-pulse-vibrant {
  0% { border-color: #dc3545; }
  50% { border-color: #f8d7da; }
  100% { border-color: #dc3545; }
}

@keyframes accent-pulse-red {
  0% { background-color: #dc3545; }
  50% { background-color: #dc3545; opacity: 0.6; }
  100% { background-color: #dc3545; }
}

.blinking-highlight {
  position: relative !important;
  overflow: hidden !important;
  transition: all 0.3s ease;
  animation: border-pulse-vibrant 2s infinite ease-in-out !important;
  border-radius: 15px !important;
  border: 2px solid #dc3545 !important;
  box-shadow: none !important;
}

/* Sidebar Items (Red Theme) */
.particular-menu .blinking-highlight {
  background: #fff5f5 !important;
  border: 1.5px solid #feb2b2 !important;
  color: #c53030 !important;
  border-radius: 8px !important;
  margin: 2px 0;
  animation: none !important;
  box-shadow: none !important;
}

.particular-menu .blinking-highlight::before {
  content: '';
  position: absolute;
  left: 0;
  top: 15%;
  height: 70%;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background-color: #dc3545 !important;
  animation: accent-pulse-red 2s infinite ease-in-out !important;
}

.blinking-highlight::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 70%
  );
  animation: shimmer 1.5s infinite linear;
  pointer-events: none;
}

.shimmer-effect {
  position: relative !important;
  overflow: hidden !important;
}

.shimmer-effect::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 70%
  );
  animation: shimmer 1.5s infinite linear;
  pointer-events: none;
}
`;

export default AnimationStyles;
